import axios from 'axios';
import { Toast, Indicator } from "mint-ui";
import QS from 'qs';
const UCAPI = '//ucapi.bookan.com.cn/'
const BKAPI = '//api.bookan.com.cn/'
let YUNNANAPI = ''

// axios.interceptors.request.use(config => {
//     let token = localStorage.getItem('token')
//     if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
//         config.headers['Authorization'] = token;
//     }
//     return config
// }, error => {
//     return Promise.reject(error)
// })

axios.defaults.headers = {
    // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    "Content-Type": "multipart/form-data"
};
axios.defaults.timeout = 180000
// axios.defaults.baseURL = 'https://opapi.bookan.com.cn/'

if (process.env.NODE_ENV === 'development') { //说明当前为开发环境
    // 开发环境相关特殊方法
    // YUNNANAPI = '//apitest-yunnan.bookan.com.cn/';
    YUNNANAPI = '//api-yunnan.bookan.com.cn/';
}
else if (process.env.NODE_ENV === 'production') {
    // 生产环境相关特殊方法
    YUNNANAPI = '//api-yunnan.bookan.com.cn/';
    // axios.defaults.baseURL = process.env.APP_BASE_URL;
}

/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function getAjax(url, params, config = { timeout: 20000, }) {
    return new Promise((resolve, reject) => {
        let token = localStorage.getItem('token')
        axios.get(YUNNANAPI + url, {
            params: params,
            headers: {
                'Authorization': token,
            }
        },
            config)
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        resolve(res.data.data);
                    } else if (res.data.code == -13) {   // token失效
                        localStorage.removeItem("token");
                        localStorage.removeItem("token_expire");
                        setTimeout(() => {
                            this.$router.replace("/");
                        }, 800);
                    } else {
                        if (url.indexOf('advertList') > -1 || url.indexOf('navigationList') > -1 || url.indexOf('live') > -1) {

                        } else {
                            Toast({
                                message: res.data.msg,
                                duration: 2000
                            });
                        }

                        Indicator.close();
                        reject(res.data)
                    }
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 2000
                    });


                    reject(err.data)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function getUCAjax(url, params, config = { timeout: 20000, }) {
    return new Promise((resolve, reject) => {
        axios.get(UCAPI + url, {
            params: params,
        }, config)
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        resolve(res.data.data);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 2000
                        });
                        Indicator.close();
                        reject(res.data)
                    }
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 2000
                    });
                    reject(err.data)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function getBKAjax(url, params, config = { timeout: 20000, }) {
    return new Promise((resolve, reject) => {
        axios.get(BKAPI + url, {
            params: params,
        }, config)
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        resolve(res.data.data);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 2000
                        });
                        Indicator.close();
                        reject(res.data)
                    }
                } else {
                    Toast({
                        message: res.data.msg,
                        duration: 2000
                    });
                    reject(err.data)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
export function postAjax(url, params, config = { timeout: 20000, }) {
    return new Promise((resolve, reject) => {
        let token = localStorage.getItem('token')
        axios.post(YUNNANAPI + url, QS.stringify(params),
            {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Authorization': token, }
            })
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        resolve(res.data);
                    } else {
                        if (res.data.code == 1012) {

                        } else {
                            Toast(res.data.msg)
                        }

                        reject(res.data)
                    }
                } else {

                    reject(err.data)
                    Message(res.data.msg)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

export function postUCAjax(url, params, config = { timeout: 20000, }) {
    let fdata = new FormData();
    Object.keys(params).forEach(key => {
        fdata.append(key, params[key]);
    })
    return new Promise((resolve, reject) => {
        axios.post(UCAPI + url, fdata,{ 'Content-Type': 'multipart/form-data' })
            .then(res => {
                if (res.status == 200) {
                    if (res.data.code == 0) {
                        resolve(res.data);
                    } else {
                        if (res.data.code == 1012) {

                        } else {
                            Toast(res.data.msg)
                        }

                        reject(res.data)
                    }
                } else {

                    reject(err.data)
                    Message(res.data.msg)
                }
            })
            .catch(err => {
                reject(err.data)
            })
    });
}